import { render } from "./MovimentoIgnoto.vue?vue&type=template&id=20efba22&scoped=true"
import script from "./MovimentoIgnoto.vue?vue&type=script&lang=js"
export * from "./MovimentoIgnoto.vue?vue&type=script&lang=js"

import "./MovimentoIgnoto.vue?vue&type=style&index=0&id=20efba22&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20efba22"]])

export default __exports__